// Mirrors the server-side default scoring in
// api/src/pickem/services/pickem.service.ts (`DEFAULT_POINTS_PER_ROUND`).
// Update both when the default scoring curve changes.
export const DEFAULT_POINTS_PER_ROUND: Record<string, number> = {
  '1': 1,
  '2': 2,
  '3': 4,
  '4': 8,
  '5': 16,
  '6': 32,
};

/**
 * Returns the points awarded for a correct pick in `roundNumber`. Falls back
 * to the shared default scoring when the event has no override, and to 1 if
 * the round is missing from the map.
 */
export function getRoundPoints(
  roundNumber: number,
  pointsPerRound: Record<string, number> | null | undefined,
): number {
  const map = pointsPerRound ?? DEFAULT_POINTS_PER_ROUND;
  return map[String(roundNumber)] ?? 1;
}

/**
 * Round labels used in the scoring summary. Matches the bracket renderer's
 * naming so the popover text feels consistent with what users see in the
 * bracket header.
 */
export function resolveRoundLabel(
  roundNumber: number,
  totalRounds: number,
): string {
  if (roundNumber === totalRounds) return 'Final';
  if (roundNumber === totalRounds - 1) return 'Semifinals';
  if (roundNumber === totalRounds - 2) return 'Quarterfinals';
  return `Round ${roundNumber}`;
}

/**
 * Number of rounds in a single-elim bracket given the starting round size.
 * (16-team → 4 rounds, 8-team → 3, etc.)
 */
export function getTotalRounds(startingRound: number): number {
  if (startingRound < 2) return 1;
  return Math.ceil(Math.log2(startingRound));
}
